module.exports = "/src/views/player/help/images/taxi3.jpg";